const apiUrl = process.env.REACT_APP_API_URL;

const parseSafeResponse = async (res) => {
    const contentType = res.headers.get('content-type') || '';

    if (contentType.includes('application/json')) {
        return await res.json();
    }

    const text = await res.text();
    console.error('[ExcelImport Service] Respuesta no JSON:', {
        status: res.status,
        statusText: res.statusText,
        bodyPreview: text?.slice(0, 300)
    });

    return {
        result: false,
        message: `El servidor respondió con un formato no válido. Status: ${res.status}`
    };
};

export const previewImport = async (payload) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/preview`;

    try {
        console.log('[ExcelImport Service] previewImport ->', url);

        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });

        return await parseSafeResponse(res);
    } catch (error) {
        console.error('previewImport error:', error);
        return {
            result: false,
            message: 'Error al generar la vista previa.',
            data: { rows: [], summary: {} }
        };
    }
};

export const commitImport = async (payload) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/commit`;

    try {
        console.log('[ExcelImport Service] commitImport ->', url);

        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });

        return await parseSafeResponse(res);
    } catch (error) {
        console.error('commitImport error:', error);
        return {
            result: false,
            message: 'Error al guardar la importación.'
        };
    }
};

//--------------------------------Conciliación Excel vs Inventario------------------------------------------------
export const buildReconciliation = async (payload) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/reconciliation/build`;
    try {
        console.log('[ExcelImport Service] buildReconciliation ->', url);
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });
        return await parseSafeResponse(res);
    } catch (error) {
        console.error('buildReconciliation error:', error);
        return {
            result: false,
            message: 'Error al generar la conciliación.',
            data: { discrepancies: [], summary: {} }
        };
    }
};

export const getReconciliationBatches = async () => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/reconciliation/batches`;

    try {
        console.log('[ExcelImport Service] getReconciliationBatches ->', url);
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return await parseSafeResponse(res);
    } catch (error) {
        console.error('getReconciliationBatches error:', error);
        return {
            result: false,
            message: 'Error al obtener los lotes de conciliación.'
        };
    }
};

export const getReconciliationList = async (params = {}) => {
    const token = sessionStorage.getItem('token');
    const query = new URLSearchParams(params).toString();
    const url = `${apiUrl}/api/configs/reconciliation/list${query ? `?${query}` : ''}`;

    try {
        console.log('[ExcelImport Service] getReconciliationList ->', url);
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return await parseSafeResponse(res);
    } catch (error) {
        console.error('getReconciliationList error:', error);
        return {
            result: false,
            message: 'Error al obtener la lista de conciliaciones.'
        };
    }
};

export const getReconciliationDetail = async (id) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/reconciliation/detail/${id}`;

    try {
        console.log('[ExcelImport Service] getReconciliationDetail ->', url);
        const res = await fetch(url, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            }
        });
        return await parseSafeResponse(res);
    } catch (error) {
        console.error('getReconciliationDetail error:', error);
        return {
            result: false,
            message: 'Error al obtener el detalle de la conciliación.'
        };
    }
};

export const assignItemToReconciliation = async (payload) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/reconciliation/assign-item`;

    try {
        console.log('[ExcelImport Service] assignItemToReconciliation ->', url);
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });
        return await parseSafeResponse(res);
    } catch (error) {
        console.error('assignItemToReconciliation error:', error);
        return {
            result: false,
            message: 'Error al asignar el ítem a la conciliación.'
        };
    }
};

export const createExcelNameMap = async (payload) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/reconciliation/create-name-map`;

    try {
        console.log('[ExcelImport Service] createExcelNameMap ->', url);
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });
        return await parseSafeResponse(res);
    } catch (error) {
        console.error('createExcelNameMap error:', error);
        return {
            result: false,
            message: 'Error al crear el mapa de nombres de Excel.'
        };
    }
};

export const markReconciliationResolved = async (payload) => {
    const token = sessionStorage.getItem('token');
    const url = `${apiUrl}/api/configs/reconciliation/mark-resolved`;

    try {
        console.log('[ExcelImport Service] markReconciliationResolved ->', url);
        const res = await fetch(url, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify(payload)
        });
        return await parseSafeResponse(res);
    } catch (error) {
        console.error('markReconciliationResolved error:', error);
        return {
            result: false,
            message: 'Error al marcar la conciliación como resuelta.'
        };
    }
};